import React from 'react';
import aiSparkleIcon from "../../../../assets/images/aiSparkleIcon.svg";    
import aiSparkeleGradientIcon from '../../../../assets/images/aiSparkleGradient.png';

const AiProductBadge = ({isAbsolute = false, transparent = false, style}) => {
    return (
        <div className={`ai-badge-container ${isAbsolute ? 'ai-badge-container-absolute' : ''}`} style={style}>
            <img src={aiSparkeleGradientIcon} alt='aiSparkleIcon' />
            <span className='ai-badge'>
                AI
            </span>
        </div>
    )
}

export default AiProductBadge;